import { Component, OnInit, Input } from '@angular/core';
import { languages } from '../languages.model';
import { SessionSetting } from '../../../app.service';

import { Pslistener } from '../../../pf.core/listener/Pslistener'
// import * as _ from 'lodash';

@Component({
  selector: 'sa-language-selector',
  templateUrl: './language-selector.component.html'
})
export class LanguageSelectorComponent implements OnInit {

  public languages: Array<any>;
  public currentLanguage: any;
  public fa = '';

  @Input() autoHideCls = 'hidden-xs';

  constructor() {}

  ngOnInit() {
    this.languages = languages;
    let key = SessionSetting.getLanguage();
    this.setLanguageByKey(key);
    this.faSet();
  }

  setLanguage(language) {
    // SessionSetting.set('i18nKey', language.key);
    this.setLanguageByKey(language.key);
    this.currentLanguage = language;
    Pslistener.i18n.next(language.key);
  }

  setLanguageByKey(key) {
    if (key) {
      this.currentLanguage = languages.find(l => l.key === key);
    } else {
      this.currentLanguage = languages[0];
    }
    SessionSetting.set('i18nKey', this.currentLanguage.key);
  }

  private faSet() {
    for (let lan of this.languages) {
      switch (lan.key) {
        case 'en-US':
        lan.fa = 'us';
        break;
        case 'ja-JP':
        lan.fa = 'jp';
        break;
        case 'zh-CN':
        lan.fa = 'cn';
        break;
        case 'zh-TW':
        lan.fa = 'tw';
        break;
        case 'ko-KR':
        lan.fa = 'kr';
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/i18n/language-selector/language-selector.component.ts